shadow$provide[2] = function(require,module,exports) {
module.exports=(React);
};